import { render, staticRenderFns } from "./QuickEndSettings.vue?vue&type=template&id=200a6932&scoped=true"
import script from "./QuickEndSettings.vue?vue&type=script&lang=ts"
export * from "./QuickEndSettings.vue?vue&type=script&lang=ts"
import style0 from "./QuickEndSettings.vue?vue&type=style&index=0&id=200a6932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200a6932",
  null
  
)

export default component.exports